const SIGNIN_ENV: Env = {
  API_BASE_URL: {
    LOC: 'http://localhost:3000/api',
    DEV: 'https://dev-account.sktapollo.com',
    STG: 'https://stg-account.sktapollo.com',
    PRD: 'https://account.sktapollo.com'
  },
  BASE_URL: {
    LOC: 'http://localhost:3000/api',
    DEV: 'https://dev-account.sktapollo.com',
    STG: 'https://stg-account.sktapollo.com',
    PRD: 'https://account.sktapollo.com'
  },
  CLIENT_ID_WITHDRAWAL: {
    LOC: '0190bfc5-884a-7fa9-9718-b01cae54e0f7',
    DEV: '0190bfc5-884a-7fa9-9718-b01cae54e0f7',
    STG: '0190bfc5-884a-7fa9-9718-b01cae54e0f7',
    PRD: 'd8a30a80-1537-4717-8dff-06921cb1ea2b'
  },
  CLIENT_SECRET_WITHDRAWAL: {
    LOC: 'c4c61c8d-d51f-46ca-8bcb-a5ef56110d18',
    DEV: 'c4c61c8d-d51f-46ca-8bcb-a5ef56110d18',
    STG: 'c4c61c8d-d51f-46ca-8bcb-a5ef56110d18',
    PRD: 'f618d93f-af6e-4430-b473-58beae4b77bc'
  }
}

export default SIGNIN_ENV
